module.exports = __webpack_public_path__ + "static/media/experience-color.5d62d6f7.svg";